<script lang="ts">
  import { onMount } from "svelte"
  import Sortable from "sortablejs"
  import { xhr, toast, wait } from "$app/utils"
  import AnnualGoal from "./AnnualGoal.svelte"
  import GoalDetail from "./GoalDetail.svelte"
  import TaskDetail from "./TaskDetail.svelte"
  import Modal from "$app/components/Modal.svelte"
  import { filterSortFn } from "./methods.svelte"
  import { appStore } from "$app/store.svelte"

  let props = $props()
  let period: "prev" | "next" = $state(props.period)

  const plan = appStore.plan
  const dates = appStore.dates
  const channel_id: string = appStore.channel_id

  let currentGoal: GoalType = $state(null)
  let openGoalDetailModal = $state(false)
  let openTaskDetailModal = $state(false)
  let currentTask: TaskTypeE = $state(null)

  function updateGoalsStore(items: GoalType[]) {
    items.forEach((item) => {
      const idx = appStore.goals.findIndex((g) => g.id === item.id)
      appStore.goals[idx] = { ...appStore.goals[idx], ...item }
    })
  }

  async function updateGoalsOrder(items: GoalType[]): Promise<void> {
    try {
      const resp = await xhr.post<{ goals: GoalType[] }>(
        `/plans/${plan.id}/goals/sort_without_department.json`,
        { goals: items.map((s) => s.id), channel: channel_id, move: true }
      )

      updateGoalsStore(resp.data.goals)
    } catch (e) {
      console.error(e)
      const tmpGoals = [...appStore.goals]
      appStore.goals = []
      await wait(50)
      appStore.goals = [...tmpGoals]
      toast("There was an error updating the sort order", "error")
    }
  }

  let sortableSection: HTMLElement = $state(null)

  /**
   * Creates sortable for goals
   */
  function setSortable(): void {
    if (!sortableSection) return
    const sort = Sortable.create(sortableSection, {
      animation: 200,
      group: `AnnualGoal-${period}`,
      scrollSensitivity: 150,
      delay: 400,
      delayOnTouchOnly: true,
      direction: "vertical",
      ghostClass: "opacity-50",
      dragClass: "border-green-400",
      emptyInsertThreshold: 20,
      onEnd: async (e: EventSortType) => {
        sort.options.sort = false
        // Move from another container
        // new sort order
        if (e.from.id === e.to.id) {
          const currentGoals = filterSortFn(appStore.goals, period, dates)

          let newGoals: GoalType[] = []
          e.from.querySelectorAll(".annual-goal").forEach((el) => {
            const id = parseInt(el.dataset.goal_id)
            const cGoal = appStore.goals.find((g) => id === g.id)
            newGoals.push(cGoal)
          })
          await updateGoalsOrder(newGoals)
          sort.options.sort = true
        }
      },
      onStart: (evt: EventSortType) => {
        appStore.draggedElement = {
          ...appStore.draggedElement,
          type: "AnnualGoal",
          id: parseInt(evt.item.dataset.id),
          goal_id: parseInt(evt.item.dataset.parent_id)
        }
      }
    })
  }

  function openGoalDetail(goal): void {
    console.log("GOAL: ", goal)
    currentGoal = goal
    openGoalDetailModal = true
  }

  function openTaskDetail(task): void {
    console.log("TASK: ", task)
    currentTask = task
    openTaskDetailModal = true
  }

  let mounted = $state(false)
  onMount(async () => {
    mounted = true
    await wait(100)
    setSortable()
  })
</script>

{#if mounted}
  {@const annualGoals = filterSortFn(appStore.goals, period, dates)}
  <section bind:this={sortableSection} id="annual-goals-{period}">
    {#each annualGoals as goal, idx (goal.id)}
      <div class="mb-1">
        <AnnualGoal
          pos={idx + 1}
          {goal}
          {period}
          onopenGoalModal={(goal) => openGoalDetail(goal)}
          onopenTaskModal={(task) => openTaskDetail(task)}
        />
      </div>
    {:else}
      <div
        class="py-6 px-2 border-gray-300 border-b border-t flex items-center justify-center font-bold shadow-sm"
      >
        No Goals
      </div>
    {/each}
  </section>
{/if}

<Modal bind:open={openGoalDetailModal} large={true}>
  <GoalDetail goalId={currentGoal.id} />
</Modal>

<Modal bind:open={openTaskDetailModal} large={true}>
  <TaskDetail taskId={currentTask.id} />
</Modal>
